import buildHasuraProvider from "ra-data-hasura";
import { createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { ApolloClient, InMemoryCache } from '@apollo/client';
import { withLifecycleCallbacks,fetchUtils } from 'react-admin';

import {
  getFileExtention,
  retrieveNewURL,
  uploadFile,
} from "./core/addUploadFile";
import { v1 as uuid } from "uuid";
import { asyncForEach } from "./core/utils/utils";

const httpLink = createHttpLink({
  uri: import.meta.env.REACT_APP_GRAPHQL_HTTP_URI,
});

const authLink = setContext((_, { headers }) => {
  return {
    headers: {
      ...headers,
      authorization: 'Bearer ' + localStorage.getItem('hz-tokenLogin'),
    },
  };
});



  const buildUploadDataProvider = async () => {
    // Create a proper Apollo Client instance for Apollo Client 4.0
    const apolloClient = new ApolloClient({
      link: authLink.concat(httpLink),
      cache: new InMemoryCache(),
    });

    const dataProvider = await buildHasuraProvider({
      client: apolloClient,
    });
  
  
    const customDataProvider = {
      ...dataProvider,
  
      customQuery: ({ query, variables }) => {
        const headers = new Headers({
          'Content-Type': 'application/json',
          authorization: 'Bearer ' + localStorage.getItem('hz-tokenLogin'),
        });
      
        return fetchUtils.fetchJson(
          import.meta.env.REACT_APP_GRAPHQL_HTTP_URI,
          {
            method: "POST",
            headers,
            body: JSON.stringify({ query, variables }),
          }
        ).then(({ json }) => {
          if (json.errors) throw json.errors;
          return json.data;
        });
      },
      
    };


  const DOWNLOAD_SERVER_ENDPOINT = "https://s3.tatweertransit.com/upload";

  const withUploadDataProvider = withLifecycleCallbacks(customDataProvider, [
    {
      resource: '*',
      beforeSave: async (params, dataProvider) => {
        console.log(params);
        let filesToUpload = [];
  
        Object.keys(params).forEach((key) => {
          console.log(params[key]);
          if (params[key]) {
            if (Array.isArray(params[key])) {
              // Handle multiple files
              params[key].forEach((file, index) => {
                if (file && file.hasOwnProperty("rawFile")) {
                  filesToUpload.push({ source: key, file, index });
                }
              });
            } else if (params[key] && params[key].hasOwnProperty("rawFile")) {
              // Handle single file
              filesToUpload.push({ source: key, file: params[key] });
            }
          }
        });
  
        let uploadedParams = { ...params };
        console.log(filesToUpload);
  
        await asyncForEach(filesToUpload, async (f) => {
          if (!f.file || !f.file.rawFile) return; // **Prevent errors if rawFile is missing**
  
          let ext = getFileExtention(f.file.rawFile);
          let fileName = `${uuid()}${ext}`;
          let url = await retrieveNewURL(fileName);
  
          console.log("Uploading file:", f.file.rawFile);
          let res = await uploadFile(f.file.rawFile, url);
          console.log("Upload result:", res);
  
          // Preserve other properties and only replace `rawFile` with `src`
          if (Array.isArray(uploadedParams[f.source])) {
            uploadedParams[f.source][f.index] = {
              ...uploadedParams[f.source][f.index], // Preserve other properties
              src: `${DOWNLOAD_SERVER_ENDPOINT}/${fileName}`,
            };
            delete uploadedParams[f.source][f.index].rawFile; // Remove rawFile
          } else {
            uploadedParams[f.source] = {
              ...uploadedParams[f.source], // Preserve other properties
              src: `${DOWNLOAD_SERVER_ENDPOINT}/${fileName}`,
            };
            delete uploadedParams[f.source].rawFile; // Remove rawFile
          }
        });
  
        console.log(uploadedParams);
        return uploadedParams; // Ensuring it only returns updated params without duplication
      },
    },
  ]);
  
  return withUploadDataProvider;
  
  
  
};




export default buildUploadDataProvider;
